import { useCollectionServices } from '../../../contexts/CollectionSourceContext';
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Menu, MenuItem } from '@mui/material';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { FitbitExtractionJob } from '../../../services/fitbitExtractionService';

export default function FitbitExtractionDownload({ studyId, job }: { studyId: string; job: FitbitExtractionJob }) {
  const { getFitbitExtractionDownload, openFitbitExtractionDownload } = useCollectionServices();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const alive = useRef(true);
  const pending = useRef(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const download = async (packaging: 'original' | 'zip') => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setAnchor(null); setError('');
    try {
      const result = await getFitbitExtractionDownload(studyId, job.jobId, packaging);
      if (alive.current) openFitbitExtractionDownload(result);
    } catch { if (alive.current) setError('Could not download this extraction. Please retry.'); }
    finally { pending.current = false; if (alive.current) setBusy(false); }
  };
  if (job.state !== 'completed') return null;
  return <Box>
    <Button size="small" variant="outlined" startIcon={<FileDownloadOutlined />} endIcon={<KeyboardArrowDown />}
      disabled={busy} aria-haspopup="menu" aria-expanded={!!anchor} onClick={event => setAnchor(event.currentTarget)} sx={{ borderRadius: '9px' }}>
      {busy ? 'Preparing download…' : 'Download'}
    </Button>
    <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
      {job.format !== 'zip' && <MenuItem onClick={() => { void download('original'); }}>Original file (.{job.format})</MenuItem>}
      <MenuItem onClick={() => { void download(job.format === 'zip' ? 'original' : 'zip'); }}>ZIP archive (.zip)</MenuItem>
    </Menu>
    {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
  </Box>;
}
